import React from 'react';
const LockSVG = ({ color = 'white', className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      className={className}
    >
      <path
        d="M5.00016 9.59076C5.57634 9.55556 6.28666 9.55556 7.20016 9.55556H15.0224C15.9359 9.55556 16.6462 9.55556 17.2224 9.59076M5.00016 9.59076C4.2811 9.63463 3.77096 9.73339 3.33553 9.95522C2.6456 10.3067 2.08467 10.8676 1.73314 11.5576C1.3335 12.342 1.3335 13.3686 1.3335 15.4222V17.1333C1.3335 19.1869 1.3335 20.2136 1.73314 20.998C2.08467 21.6879 2.6456 22.2488 3.33553 22.6003C4.11987 23 5.14663 23 7.20016 23H15.0224C17.076 23 18.1026 23 18.8871 22.6003C19.577 22.2488 20.1379 21.6879 20.4894 20.998C20.8891 20.2136 20.8891 19.1869 20.8891 17.1333V15.4222C20.8891 13.3686 20.8891 12.342 20.4894 11.5576C20.1379 10.8676 19.577 10.3067 18.8871 9.95522C18.4516 9.73339 17.9414 9.63463 17.2224 9.59076M5.00016 9.59076V7.11111C5.00016 3.73604 7.7362 1 11.1113 1C14.4863 1 17.2224 3.73604 17.2224 7.11111V9.59076"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LockSVG;
